import { DEFAULT_CURRENCY } from '@typings/common';

const priceWithCurrency = (num: number, currency: string): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    currency,
    minimumFractionDigits: 2,
    style: 'currency',
  });
  let suffix = '';
  if (currency === DEFAULT_CURRENCY) {
    suffix = ` ${DEFAULT_CURRENCY}`;
  }
  return `${formatter.format(num)}${suffix}`;
};

export default priceWithCurrency;